import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getWorksServicePaymentRateNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].GET_WORKS_SERVICE_PAYMENT_RATE_NORMS,
	},
	getBaseWorksServicePaymentRateNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].GET_WORKS_SERVICE_PAYMENT_RATE_NORMS,
	},
	getExtendedWorksServicePaymentRateNorms: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].GET_WORKS_SERVICE_PAYMENT_RATE_NORMS,
	},
	createWorksServicePaymentRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].CREATE_WORKS_SERVICE_PAYMENT_RATE_NORM,
	},
	getWorksServicePaymentRateNorm: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].GET_WORKS_SERVICE_PAYMENT_RATE_NORM,
	},
	patchWorksServicePaymentRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].PATCH_WORKS_SERVICE_PAYMENT_RATE_NORM,
	},
	putWorksServicePaymentRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].PUT_WORKS_SERVICE_PAYMENT_RATE_NORM,
	},
	deleteWorksServicePaymentRateNorm: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS].DELETE_WORKS_SERVICE_PAYMENT_RATE_NORM,
	},
}